<template>
    <span v-if="platformAvailable" class="mr-3">
        <b-button
            :block="block"
            v-if="buttonDisplay"
            :size="buttonSize"
            :variant="buttonVariant"
            class="cancel-btn mr-3 integration-btn"
            @click="loginWith"
        >
            <third-party-platform-icon :platform="platform" :display-alt="displayTextCached"/> {{ displayTextCached }}&reg;
        </b-button>
        <a
            v-else
            class="ml-1 mr-1 font-weight-bold text-nowrap"
            href="javascript:void(0)"
            @click="loginWith"
        >
            {{ displayTextCached }}
        </a>
    </span>
</template>

<script>
import {thirdPartyService} from "@packages/integrations/service";
import ThirdPartyPlatformIcon from "./ThirdPartyPlatformIcon";

export default {
    name: "ThirdPartyPlatformLogin",
    components: {
        ThirdPartyPlatformIcon
    },
    props: {
        externalId: {
            type: String,
            default: 'NEW-' + Math.round(Math.random() * 100000000000000000),
        },
        orderAppResource: {
            type: Object,
            default: null,
        },
        platform: {
            type: String,
            required: true,
        },
        redirectPage: {
            type: String,
            required: true,
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        buttonDisplay: {
            type: Boolean,
            default: true,
        },
        buttonSize: {
            type: String,
            default: 'primary',
        },
        buttonVariant: {
            type: String,
            default: 'md',
        },
        displayText: {
            type: String,
            default: '',
        },
        block:{
            type: Boolean,
            default: true
        }
    },
    computed: {
        async platformAvailable() {
            return this.enabled && await thirdPartyService.isPlatformAvailable(this.platform);
        },
        orderUuid() {
            return this.orderAppResource?.uuid || null;
        },
        displayTextCached() {
            if (this.displayText) {
                return this.displayText;
            }
            switch (this.platform) {
                case 'lonewolf':
                case 'zipform':
                    return 'zipForm';
                case 'dotloop':
                    return 'dotLoop';
            }
        },
    },
    methods: {
        loginWith() {
            return thirdPartyService.redirectToLogin(this.externalId, this.redirectPage, this.orderUuid, this.platform);
        }
    },
}
</script>